import { Box, Stack, Tabs, Typography } from "@mui/material";
import {
  PaperMaterialInventoriesPermission,
  PaperMaterialsPermission,
} from "commons/enum/permission";
import { useCheckPermission } from "commons/hooks/use-check-permission";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { XTab } from "share-components/mui-wrap/tab/x-tab";
import { PageContainer } from "share-components/templates/page/page-container";
import { PaperGoodsIssueList } from "./paper-goods-issue-list/paper-goods-issue-list";
import { PaperGoodsReceiptList } from "./paper-goods-receipt-list/paper-goods-reciept-list";
import { PaperInventoryList } from "./paper-inventory-list/paper-inventory-list";
import { PaperMaterialList } from "./paper-material-list/paper-material-list";

export const PaperInventory = observer(() => {
  return (
    <PageContainer>
      <Outlet></Outlet>
    </PageContainer>
  );
});
export enum PaperInventoryTab {
  PaperMaterial = "PaperMaterial",
  PaperInventory = "PaperInventory",
  PaperGoodsReceipt = "PaperGoodsReceipt",
  PaperGoodsIssue = "PaperGoodsIssue",
}
export const PaperInventoryHome = observer(() => {
  const {
    paperInventoryManagement: { tabSelected, setProp },
  } = useStores();
  const { accessKey, allowAccess } = useCheckPermission([
    PaperMaterialInventoriesPermission.Default,
    PaperMaterialsPermission.Default,
    PaperMaterialInventoriesPermission.Receipt,
    PaperMaterialInventoriesPermission.Issue,
  ]);

  useEffect(() => {
    if (allowAccess && accessKey) {
      const getTabSelected = (accessKey: string) => {
        switch (accessKey) {
          case PaperMaterialInventoriesPermission.Default:
            return PaperInventoryTab.PaperInventory;
          case PaperMaterialsPermission.Default:
            return PaperInventoryTab.PaperMaterial;
          case PaperMaterialInventoriesPermission.Receipt:
            return PaperInventoryTab.PaperGoodsReceipt;
          case PaperMaterialInventoriesPermission.Issue:
            return PaperInventoryTab.PaperGoodsIssue;
          default:
            return null;
        }
      };
      setProp("tabSelected", getTabSelected(accessKey));
    }
  }, [accessKey, allowAccess, setProp]);

  return (
    <Stack
      flex={1}
      direction={"column"}
      spacing={2}
      sx={{ overflow: "hidden" }}
    >
      <Stack direction={"row"}>
        <Typography variant="subtitle2">Quản lý tồn kho giấy</Typography>
      </Stack>
      <Box>
        <Tabs
          value={tabSelected}
          onChange={(_, value) => {
            setProp("tabSelected", value);
          }}
        >
          <XTab
            accessPermission={[PaperMaterialsPermission.Default]}
            label="Quản lý vật tư giấy"
            value={PaperInventoryTab.PaperMaterial}
          />
          <XTab
            accessPermission={[PaperMaterialInventoriesPermission.Default]}
            label="Tồn kho vật tư giấy"
            value={PaperInventoryTab.PaperInventory}
          />
          <XTab
            accessPermission={[PaperMaterialInventoriesPermission.Receipt]}
            label="Nhập kho"
            value={PaperInventoryTab.PaperGoodsReceipt}
          />
          <XTab
            accessPermission={[PaperMaterialInventoriesPermission.Issue]}
            label="Xuất kho"
            value={PaperInventoryTab.PaperGoodsIssue}
          />
        </Tabs>
      </Box>
      <Stack flex={1} sx={{ overflow: "hidden", paddingBlockStart: 1 }}>
        {tabSelected === PaperInventoryTab.PaperMaterial && (
          <PaperMaterialList />
        )}
        {tabSelected === PaperInventoryTab.PaperInventory && (
          <PaperInventoryList />
        )}

        {tabSelected === PaperInventoryTab.PaperGoodsReceipt && (
          <PaperGoodsReceiptList></PaperGoodsReceiptList>
        )}

        {tabSelected === PaperInventoryTab.PaperGoodsIssue && (
          <PaperGoodsIssueList></PaperGoodsIssueList>
        )}
      </Stack>
    </Stack>
  );
});
